import { FunctionComponent } from "react";
import styles from "../stylesheets/components/media-library-image-check.module.css";
import Icon from "./Icon.js";

const MediaLibraryImageCheck: FunctionComponent = () => {
  return (
    <div className={styles.MediaLibrary__Image__Check}>
      <Icon glyph="check" className={styles.Icon} />
    </div>
  );
};

export default MediaLibraryImageCheck;
